
import Vue from "vue";
import { Alert } from "@/commons/types";
import Alerter from "@/components/Alerter.vue";
import PasswordChange from "@/components/PasswordChange.vue";
import OrganizationCard from "@/components/OrganizationCard.vue";
import { UserSchema, UserUpdateSchema, UsersService } from "@/commons/client";

export default Vue.extend({
  name: "Profile",

  components: {
    PasswordChange,
    OrganizationCard,
    Alerter,
  },

  data: () => ({
    userFormData: {} as UserUpdateSchema,
    isUpdatingProfile: false,
    alerts: [] as Alert[],
  }),

  computed: {
    userData(): UserSchema {
      return (this as any).$store.state.user;
    },
    organizationId() {
      return (this as any).$store.state.organizationId;
    },
    rules(): any {
      return (this as any).$store.state.genericRules;
    },
    icon(): string {
      return !this.isUpdatingProfile ? "mdi-pencil" : "mdi-pencil-off";
    },
    maxCardWidth(): number {
      const bpName = this.$vuetify?.breakpoint?.name;

      return bpName === "xs" || bpName === "sm" ? 400 : 550;
    },
    hasLimitedDataAccess(): boolean {
      return !!(this as any).$store.state.user?.has_limited_data_access;
    },
  },

  methods: {
    setData(user: UserSchema): void {
      /*************************************
       * Set the data to the form
       *************************************/
      this.userFormData = {
        username: user.username,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
      };
    },
    setUserData(): void {
      /*************************************
       * Set the data to be displayed in the
       * form.
       *************************************/
      this.setData(this.userData);
    },
    async updateProfile(): Promise<void> {
      const id = this.userData?.id;
      if (typeof id !== "number") {
        this.alerts.push({
          type: "error",
          text: "ID utente non disponibile. Riprova dopo il refresh.",
        });
        return;
      }

      try {
        const res = await UsersService.userUpdateV1UsersPkPut(
          id,
          this.userFormData
        );
        this.setData(res);
        (this as any).$store.commit("setUser", res);
        this.alerts.push({
          type: "success",
          text: "Profilo aggiornato con successo!",
        });
      } catch (err: unknown) {
        const message =
          (err as any)?.body?.detail ||
          (err as Error)?.message ||
          "Errore durante l'aggiornamento del profilo";
        this.alerts.push({ type: "error", text: message });
      } finally {
        this.isUpdatingProfile = false;
      }
    },
    toggleUpdate() {
      /**********************
       * Toggle update
       **********************/
      this.isUpdatingProfile = !this.isUpdatingProfile;
    },
  },

  created() {
    this.setUserData();
  },
});
